if(window.location.pathname.includes("/pages")) {
    document.addEventListener("click", (e) => {
    if (e.target.tagName === "LI") {
            setTimeout(() => {
              const customEvent = new Event("BSS_condition_field_change");
        document.dispatchEvent(customEvent);
      }, 100);
    }
  });
  
  document.addEventListener(
    "change",
    (event) => {
      setTimeout(() => {
        const customEvent = new Event("BSS_condition_field_change");
        document.dispatchEvent(customEvent);
      }, 100);
    },
    true
  );
}

if('/pages/wholesale-registration-v2' === window.location.pathname) {
    let counter = 0;
    const maxWaitTime = 10000;
    const intervalTime = 100;
    
    const selector = '.text-field-1922e1b993bb7';
    
    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        const utmParams = localStorage.getItem('utm_params') ?? "";
        element.value = utmParams;
        clearInterval(interval);
      } else {
        counter += intervalTime;
        if (counter >= maxWaitTime) {
          clearInterval(interval);
        }
      }
    }, intervalTime);
}